import BaseVM from "common/forms/ExternalFormsViewModel";
import urlapi from "common/managers/urlapi";
import topic from "common/managers/topic";
import window from "common/objects/window";
import functions from "common/helper/functions";
export default kendo.data.ObservableObject
    .extend(BaseVM)
    .extend({

        maxWidth: "100%",

        isEmbedded: function() {
            return window.self !== window.parent;
        },

        onInit: function() {
            BaseVM.onInit.apply(this, arguments);
            if (window.self !== window.top) {
                this.sendResizeInfo = functions.debounceAnimate(this.sendResizeInfo, this);
                $(window).on("resize", this.sendResizeInfo);
            } else {
                this.sendResizeInfo = function() {};
            }
        },
        onShow: function() {
            var me = this;
            urlapi.loadHash(window.location.hash, true).done(function() {
                me.handleUrlApi()
                    .always(function() {
                        topic.publish("app/ready");
                    });
            });

        },
        //showSuccess, showError, showForm, currentStep.controlsDS
        onDisplayChange: function(e) {
            BaseVM.onDisplayChange.apply(this, arguments);
            if (e.field === "showSuccess" || e.field === "showError" || e.field === "showForm" || e.field === "currentStep" || e.field === "currentStep.controlsDS") {
                this.sendResizeInfo();
            }
        },

        _lastHeight: 0,

        _getCurrentSize: function() {
            var form = this.formContainer().getHeight();
            var error = this.errorContainer()[0].getBoundingClientRect().height;
            var success = this.successContainer()[0].getBoundingClientRect().height;
            return Math.ceil(form + error + success);
        },

        setMaxWidth: function(e) {
            if (this.get("maxWidth") !== e.size) {
                this._lastWidth = e.size;
                this.set("maxWidth", e.size);
                window.parent.postMessage({
                    width: this._lastWidth
                }, "*")
            }
        },

        sendResizeInfo: function() {
            var sizeNow = this._getCurrentSize();
            if (this._lastHeight !== sizeNow) {
                this._lastHeight = sizeNow;
                window.parent.postMessage({
                    height: sizeNow
                }, "*")
            }

        }
    });
